import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { maquinasApi } from '@/lib/api';
import type { Maquina, StatusMaquina } from '@/types';

export function useMaquinas() {
  return useQuery({
    queryKey: ['maquinas'],
    queryFn: async () => {
      const response = await maquinasApi.listar();
      const data = response.data;
      if (data && typeof data === 'object' && 'data' in data && Array.isArray(data.data)) {
        return data.data as Maquina[];
      }
      return (Array.isArray(data) ? data : []) as Maquina[];
    },
  });
}

export function useMaquinasDisponiveis() {
  return useQuery({
    queryKey: ['maquinas-disponiveis'],
    queryFn: async () => {
      const response = await maquinasApi.disponiveis();
      const data = response.data;
      if (data && typeof data === 'object' && 'data' in data && Array.isArray(data.data)) {
        return data.data as Maquina[];
      }
      return (Array.isArray(data) ? data : []) as Maquina[];
    },
  });
}

export function useMaquina(id: string) {
  return useQuery({
    queryKey: ['maquina', id],
    queryFn: async () => {
      const response = await maquinasApi.buscar(id);
      return (response.data.data || response.data) as Maquina;
    },
    enabled: !!id,
  });
}

export function useCriarMaquina() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: any) => maquinasApi.criar(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['maquinas'] });
    },
  });
}

export function useAtualizarMaquina() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      maquinasApi.atualizar(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['maquinas'] });
    },
  });
}

export function useAtualizarStatusMaquina() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: StatusMaquina }) =>
      maquinasApi.atualizarStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['maquinas'] });
    },
  });
}

export function useDeletarMaquina() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => maquinasApi.deletar(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['maquinas'] });
    },
  });
}

export function useIniciarImpressao() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: { produtoId: string, arquivoUrl: string, nomeArquivo: string } }) =>
      maquinasApi.iniciarImpressao(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['maquinas'] });
    },
  });
}
